import { numberWithCommas, unlimitedParse } from '@callrail/looky/util';

import { platformDisplayInfo } from '../interfaces/plan-display-info';
import { PlatformPricing } from '../interfaces/platform-pricing';
import { ProductType } from '../type-aliases/product-type';
import { PlatformModel } from './platform.model';

export class VoiceAssistPlatformModel extends PlatformModel {
  public voice_assist_calls: PlatformPricing;

  public platform: ProductType = 'voice_assist';
  public platformInfo = platformDisplayInfo[this.platform];

  public displayText;

  constructor(platformPlan) {
    super(platformPlan);
    Object.assign(this, platformPlan);
    this.setDisplayText();
  }

  public get _usageInfo(): string[] {
    return [
      `${this.voice_assist_calls.included_units} voice assist calls per month; \
      $${this.voice_assist_calls.additional_price} each additional`,
    ];
  }

  public get _unitPrice(): number {
    return this.price;
  }

  private setDisplayText() {
    this.displayText = {
      marketingCopyA: `${numberWithCommas(
        unlimitedParse(this.voice_assist_calls?.included_units)
      )} voice assist calls`,
      // marketingCopyB: ``,
      // marketingCopyC: ``,
    };
  }
}
